import { useAppSelector } from '@shared/store';
import { selectCurrentCompanyId } from '@entities/account';

export const useAccountCompanyId = () => {
  const companyId = useAppSelector(selectCurrentCompanyId);

  return companyId;
};
